import dynamic from 'next/dynamic';

export const DolEditor = dynamic<any>(
  () => import('./DolEditorBase').then((mod) => mod.DolEditor),
  {
    ssr: true,
  },
);

